import { Checkbox, FormControl, FormHelperText, FormLabel } from '@mui/material'
import React from 'react'
import { Controller, FieldValues, Path, useFormContext } from 'react-hook-form'

type Props<T extends FieldValues> = {
  name: Path<T>
  label?: React.ReactNode
  required?: boolean
} & Pick<React.ComponentProps<typeof Checkbox>, 'disabled' | 'autoFocus'>

// a single checkbox for boolean value, similar to RHFSwitch but using Checkbox component (For Terms and Conditions)
export function RHFSingleCheckbox<T extends FieldValues>({ name, label, required, ...props }: Props<T>) {
  const { control } = useFormContext<T>()

  return (
    <Controller
      name={name}
      control={control}
      render={({ field, fieldState }) => (
        <FormControl error={!!fieldState.error} fullWidth sx={{ mb: 2, mx: '-9px' }}>
          <div style={{ display: 'flex', gap: 1, alignItems: 'center' }}>
            <Checkbox
              {...field}
              {...props}
              checked={field.value || false}
              id={`rhf-${name}`}
              slotProps={{
                input: { 'aria-label': name },
              }}
              onChange={(e) => field.onChange(!!e.target.checked)}
            />
            <FormLabel htmlFor={`rhf-${name}`} required={required} sx={{ cursor: 'pointer' }}>
              {label}
            </FormLabel>
          </div>
          <FormHelperText>{fieldState.error?.message}</FormHelperText>
        </FormControl>
      )}
    />
  )
}
